module.exports = __webpack_public_path__ + "img/flexslider-icon.10e8a545.svg";